import { render, staticRenderFns } from "./MenuPc.vue?vue&type=template&id=389d0cbd&scoped=true"
import script from "./MenuPc.vue?vue&type=script&lang=js"
export * from "./MenuPc.vue?vue&type=script&lang=js"
import style0 from "./MenuPc.vue?vue&type=style&index=0&id=389d0cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d0cbd",
  null
  
)

export default component.exports